import 'babel-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import store from 'redux/redux'
import registerServiceWorker from './registerServiceWorker'

import SetUp from './setup'

ReactDOM.render(
  <Provider store={store}>
    <SetUp />
  </Provider>,
  document.getElementById('root')
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js